
import React from "react";
import { FaArrowRight } from "react-icons/fa";
import Img1 from "../../assests/jewerally.avif"; // replace with your actual image path
import Img2 from "../../assests/shopjewerally.jpeg"; // replace with your actual image path
import { Link } from "react-router-dom";

const VisitStorePage: React.FC = () => {
  return (
    <div className="text-gray-800 p-8 min-h-screen flex flex-col justify-start items-center" style={{ fontFamily: 'Arial' }}>
  <h2 className="text-center text-3xl md:text-4xl font-semibold mb-6 font-[Cinzel] bg-gradient-to-r from-yellow-600 via-yellow-500 to-yellow-400 bg-clip-text text-transparent relative py-5 lg:px-20">
    Visiting Sardar Stores
  </h2>

      
      {/* Main Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl w-full items-center">
        
        {/* Left Text Content */}
        <div>
          <h1 className="text-6xl font-bold mb-6">Visit Sardar Stores</h1>
          <p className="text-lg mb-6">
            SARDAR's hospitality is an experience to live. Come and try magnificent jewellery and live this grandeur experience in a Sardar store near you.
          </p>
         <Link
  to="/contact"   
  className="w-32 bg-amber-700 hover:bg-amber-800 text-white px-6 py-3 flex items-center gap-2 rounded-md transition duration-300"
>
  Visit Us
  <FaArrowRight className="text-white" />
</Link>
        </div>

        {/* Right Image Section */}
        <div className="relative">
          <img
            src={Img1} // replace with your actual image path
            alt="Store"
            className="rounded-lg shadow-lg"
          />
          
          {/* Jewellery floating image */}
          <img
            src={Img2} // replace with your actual image path
            alt="Jewellery"
            className="w-32 absolute bottom-0 right-0 transform translate-x-1/4 translate-y-1/4 rounded-lg shadow-md border-4 border-white"
          />
        </div>
      </div>

    </div>
  );
};

export default VisitStorePage;
      